import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NewVsRepeatedDonorsChart from "./NewVsRepeatedDonorsChart";

// Static data for new vs repeated donors
const STATIC_DONOR_DATA = {
  newDonors: 1250,
  repeatedDonors: 3480,
};

const NewVsRepeatedDonorsWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("New vs Repeated Donors")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <NewVsRepeatedDonorsChart data={STATIC_DONOR_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default NewVsRepeatedDonorsWrapper;
